import React from 'react';
import AutoSizeTitle from '../../../components/autoSizeTitle/AutoSizeTitle';
import IndividualInformHeader from '../../../components/individualInformHeader/individualInformHeader';
import ResumeRadarSelfcare from '../../../graphics/selfcare/resumeRadarSelfcare';
import {
    SELFCARE_DIMENSION_DEFS,
    getDimensionsEntries,
    getGlobalNarrative,
    getVisibleSelfcareGlobalScore,
} from '../selfcareReportLogic';
import '../resumeSelfcare.css';

const DIMENSION_LEGEND = SELFCARE_DIMENSION_DEFS
    .slice()
    .sort((a, b) => a.radarOrder - b.radarOrder)
    .map((dimension) => ({
        code: dimension.code,
        label: dimension.reportTitle.replace(/^D\d\s+/, ''),
    }));

const PageResumeSelfcare_2 = ({ selectedEvaluation, individualResult, pageNumber, orgLogo, totalResults }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const dimensionsEntries = getDimensionsEntries(individualResult, { order: 'radar' });
    const visibleGlobalScore = getVisibleSelfcareGlobalScore(individualResult);

    const globalDimensions = React.useMemo(() => {
        const byDim = totalResults?.average_by_dimension;
        if (!byDim) return null;

        // Build a lookup: code → average from totalResults (keys may be IDs or titles, not "D1")
        const globalByCode = {};
        Object.entries(byDim).forEach(([key, entry]) => {
            const title = entry?.title || key;
            // Try to extract code like "D1" from key or title
            const match = String(title).toUpperCase().match(/D[1-7]/) ||
                          String(key).toUpperCase().match(/D[1-7]/);
            if (match) {
                globalByCode[match[0]] = entry?.average ?? null;
            }
        });

        if (Object.keys(globalByCode).length === 0) return null;

        return SELFCARE_DIMENSION_DEFS
            .slice()
            .sort((a, b) => a.radarOrder - b.radarOrder)
            .map((def) => ({
                code: def.code,
                key: def.code,
                title: def.reportTitle,
                reportTitle: def.reportTitle,
                average: globalByCode[def.code] ?? null,
            }));
    }, [totalResults]);

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation?.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                    <div className="selfcare-resume-section">
                        <div className="selfcare-resume-title">Resumen</div>

                        <div className="selfcare-resume-narrative">
                            {getGlobalNarrative(visibleGlobalScore)}
                        </div>
                    </div>

                    <div className="selfcare-radar-section">
                        <div className="selfcare-radar-title">
                            Modelo de Autocuidado
                            <br />
                            y Seguridad
                        </div>
                        <div className="selfcare-radar-wrapper">
                            <ResumeRadarSelfcare dimensions={dimensionsEntries} globalDimensions={globalDimensions} />
                        </div>
                        {globalDimensions && (
                            <div style={{ display: 'flex', justifyContent: 'center', gap: 20, fontSize: '0.72em', marginBottom: 4 }}>
                                <span><span style={{ display: 'inline-block', width: 18, height: 3, backgroundColor: '#ff7a00', verticalAlign: 'middle', marginRight: 4 }} /> Individual</span>
                                <span><span style={{ display: 'inline-block', width: 18, height: 3, backgroundColor: '#3E246B', verticalAlign: 'middle', marginRight: 4, borderTop: '2px dashed #3E246B' }} /> Empresa</span>
                            </div>
                        )}
                        <div className="selfcare-dimension-code-legend selfcare-dimension-code-legend--radar">
                            {DIMENSION_LEGEND.map((dimension) => (
                                <div key={dimension.code} className="selfcare-dimension-code-legend-item">
                                    <span className="selfcare-dimension-code-legend-code">{dimension.code}</span>
                                    <span className="selfcare-dimension-code-legend-text">{dimension.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResumeSelfcare_2;
